import { getBearerToken, mouseEventStyles, Page, dynamicResourceLinks } from "./util";
import ControlPannel from "./ControlPannel";
import CustomLink from "./CustomLink";
import axios from "axios";
import $ from 'jquery'
import InputPassword from "./InputPassword";

const CreateUser = () => {
	return (
		<Page className="create-user">
			<div className="navpad h50"></div>
			<ControlPannel >
				<CustomLink className="users left"
					to={"/users"}
					{...mouseEventStyles(
						{ backgroundColor: "rgba(255, 255, 255, 0.2)" },
						{ backgroundColor: "rgba(255, 255, 255, 0.3)" }
					)}>
					<img src={dynamicResourceLinks("ff09ff").userIcon} alt="" className="icon" />
					<div className="tooltip">
						manage users
					</div>
				</CustomLink>
				<div></div>
			</ControlPannel>
			<form action="" onSubmit={(e) => {
				e.preventDefault()
				if ($("#password").val() !== $("#cpassword").val()) {
					$("#message").removeAttr("style")
					$("#message").text("Passwords do not match!")
					$("#message").attr("style", "color: orangered")
					return
				}
				var data = new FormData();
				var count = 0
				var append = (key) => {
					// console.log($("#" + key).val())
					data.append(key, $("#" + key).val())
					if ($("#" + key).val() !== "")
						count++
				}
				append('username');
				append('name');
				append('email');
				append('password');
				data.append('avatar', 1)
				if (count === 4)
					axios.post("https://api.pcbang.ma/api/users", data, {
						headers: {
							Authorization: getBearerToken(),
							'Content-Type': 'multipart/form-data'
						}
					}).then((res) => {
						if (res.status === 201) {
							$("#message").removeAttr("style")
							$("#message").text("Success!")
							$("#message").attr("style", "color: lime")
							setTimeout(() => {
								if (!String(window.location).startsWith("/users"))
									window.location = "/users"
							}, 1500)
						}
					}).catch((err) => {
						console.log({ err })
						$("#message").removeAttr("style")
						$("#message").text(err.response.data.error.message + "!")
						$("#message").attr("style", "color: orangered")
					})
				else {
					$("#message").removeAttr("style")
					$("#message").text("Some of the fields are still blank!")
					$("#message").attr("style", "color: orangered")
				}
			}}>
				<label htmlFor="">Username: </label>
				<input type="text" name="" id="username" />
				<label htmlFor="">Author Name: </label>
				<input type="text" name="" id="name" />
				<label htmlFor="">Email: </label>
				<input type="text" name="" id="email" />
				<label htmlFor="">Password: </label>
				<InputPassword type="password" name="" id="password" />
				<label htmlFor="">Confirm Password: </label>
				<InputPassword type="password" name="" id="cpassword" />
				<p htmlFor="" id="message" className="flex-as-cr"><wbr></wbr></p>
				<input type="submit" name="submit" value="Create User" className="submitbutton" />
				<div className="navpad"></div>
			</form>
		</Page>
	);
}

export default CreateUser;